<section
  class="ai-assistant-panel"
  [class.ai-assistant-panel-open]="isOpen"
  [class.ai-assistant-panel-maximized]="isMaximized"
  [class.ai-assistant-panel-vertical]="viewMode === 'vertical'"
  aria-live="polite"
>
  <header class="ai-assistant-header">
    <h2>{{ title | translate }}</h2>
    <div class="ai-assistant-header-actions">
      <ion-button
        fill="clear"
        size="small"
        type="button"
        class="ai-assistant-follow-toggle"
        [class.ai-assistant-follow-on]="followMode"
        (click)="toggleFollowMode()"
        [attr.aria-pressed]="followMode"
        [attr.aria-label]="followMode ? 'Stop following the assistant' : 'Follow the assistant as it works'"
        [title]="followMode ? 'Following the assistant' : 'Not following — screens still refresh'"
      >
        <ion-icon [src]="followMode ? 'assets/icon/assistant-follow-active.svg' : 'assets/icon/assistant-follow.svg'"></ion-icon>
      </ion-button>
      <ion-button fill="clear" size="small" type="button" (click)="toggleSidePanel()" [attr.aria-label]="viewMode === 'vertical' ? 'Restore floating view' : 'Open side panel view'">
        <ion-icon [src]="viewMode === 'vertical' ? 'assets/icon/assistant-float.svg' : 'assets/icon/assistant-dock.svg'"></ion-icon>
      </ion-button>
      <ion-button fill="clear" size="small" type="button" (click)="toggleMaximize()" [attr.aria-label]="isMaximized ? 'Restore blue.print agent' : 'Maximize blue.print agent'">
        <ion-icon [src]="isMaximized ? 'assets/icon/assistant-collapse.svg' : 'assets/icon/assistant-expand.svg'"></ion-icon>
      </ion-button>
      <ion-button fill="clear" size="small" type="button" (click)="closeAssistant()" aria-label="Close blue.print agent">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </div>
  </header>

  <div class="ai-assistant-frame-shell">
    <iframe
      #assistantFrame
      class="ai-assistant-frame"
      [src]="trustedAssistantUrl"
      title="blue.print agent"
      (load)="onIframeLoad()"
      allow="microphone; clipboard-read; clipboard-write"
    ></iframe>
  </div>
</section>

<img
  *ngIf="!isOpen || (isOpen && viewMode === 'floating' && !isMaximized)"
  class="ai-assistant-launcher"
  [src]="assistantIconPath"
  alt="Open blue.print agent"
  role="button"
  tabindex="0"
  (click)="openAssistant('floating')"
  (keyup.enter)="openAssistant('floating')"
  (keyup.space)="openAssistant('floating')"
/>